import { render } from "./MainLoginPage.vue?vue&type=template&id=39993482"
import script from "./MainLoginPage.vue?vue&type=script&lang=js"
export * from "./MainLoginPage.vue?vue&type=script&lang=js"

import "./MainLoginPage.vue?vue&type=style&index=0&id=39993482&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__